import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';

interface OrgTopbarProps {
  onMenuClick: () => void;
  /** Optional right-side action — used by OrgShell to inject a
      route-specific control (e.g. "New Template" on the templates route). */
  action?: ReactNode;
}

// Map paths to section titles
const getSectionTitle = (pathname: string): string => {
  if (pathname.includes('/templates')) {
    if (pathname.includes('/new')) return 'New Template';
    if (pathname.includes('/builder')) return 'Template Builder';
    return 'Templates';
  }
  if (pathname.includes('/users')) return 'Team';
  if (pathname.includes('/settings')) return 'Settings';
  if (pathname.includes('/archive')) return 'Archive';
  if (pathname.includes('/contracts')) return 'Contracts';
  return 'Overview';
};

export const OrgTopbar = ({ onMenuClick, action }: OrgTopbarProps) => {
  const pathname = useLocation().pathname;
  const sectionTitle = getSectionTitle(pathname);

  return (
    <div className=" z-40 h-14 border-b border-border bg-[hsl(var(--bg))]/95 backdrop-blur-sm md:hidden flex justify-between items-center gap-2 px-3">
      <div className="flex h-full items-center min-w-0">
        {/* Mobile menu button + Section title */}
        <Button variant="ghost" size="icon" onClick={onMenuClick} className="h-9 w-9 mr-1 shrink-0">
          <Menu className="h-5 w-5" />
        </Button>
        <h1 className="md:text-lg font-semibold text-[hsl(var(--fg))] font-heading truncate">
          {sectionTitle}
        </h1>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
};
